import { scrollToAnimated } from "../scroll-to-animated";
import { Analytics } from "../../utils/analytics/analytics";
import { useSmartBannerPosition } from "./use-smartbanner-position";
import { useHeader } from "./header";

class MainMenu {
    static isMobile = false;
    static dataLayerLogged = false;

    static showHeader() {
        useHeader().setHeaderState({ active: true, parallax: false, transparent: false, animated: true });
    }

    static toggleMMLevels() {
        const mainMenu = $("#mainMenu");
        const mainMenuLi = $("#mainMenu > li");
        const buttonBack = '<li id="buttonBack">Zpět</li>';

        // init fn which turn the mobile menu on
        const init = () => {
            // add back button

            if ($("#buttonBack")) {
                $("#buttonBack").remove();
            }
            $(mainMenu).prepend(buttonBack);
            $("#buttonBack").hide();

            this.isMobile = true;

            // click on zero level <li> in mainMenu
            $(mainMenuLi).click(function (e) {
                // if target is anchor finish function execution
                if (e.target.tagName.toLowerCase() === "a") {
                    return;
                }
                // if <li> has <ul>
                if ($(this).find("> ul").length > 0) {
                    // show back button
                    $("#buttonBack").show();

                    // hide accordion nav
                    $(".mm-accordions").hide();

                    // hide all zero level <li>
                    $(mainMenuLi).each(function () {
                        $(this).hide();
                    });
                    // hide other navigations and banner except of this .mm-levels menu
                    $(".main-menu__scrollable > *:not(.mm-levels)").hide();
                    // show only current zero level with its child <ul>
                    $(this).css("display", "block");
                    $(this).find("> a").hide();
                    //$(this).find('> ul').css('display', 'block');
                    $(this).find("> ul").css("left", "0").css("position", "relative");
                }
            });

            // buttonBack events
            $("#buttonBack").click(function () {
                $(this).hide();

                // show and accordion nav
                $(".mm-accordions").css("display", "block");

                $(mainMenuLi).css("display", "block");
                //$(mainMenuLi).find('> ul').css('display','none');
                $(mainMenuLi).find("> ul").css("left", "100%").css("position", "fixed");
                $(mainMenuLi).find("> a").css("display", "inline-block");
                // show other navigations and banner except of this .mm-levels menu
                $(".main-menu__scrollable > *:not(.mm-levels)").css("display", "block");
            });
        };

        // fn which turn the mobile menu off
        const ban = () => {
            // unbind click fns for mobile menu
            $(mainMenuLi).off("click");
            $("#buttonBack").off("click");

            // reset mobile styles set in init fn
            $(mainMenuLi).css("display", "");
            $(mainMenuLi).find("li").css("display", "");
            $(mainMenuLi).find("> ul").css("left", "").css("position", "");
            $(mainMenuLi).find("> a").css("display", "");

            // show and accordion nav
            $(".mm-accordions").css("display", "");
            $("#buttonBack").hide();
            this.isMobile = false;
        };

        // call on load if media matches
        if (!window.matchMedia("(min-width: 768px)").matches) {
            init();
        }

        // call on resize of media matches
        window.addEventListener(
            "resize",
            () => {
                if (!window.matchMedia("(min-width: 768px)").matches) {
                    if (!this.isMobile) {
                        init();
                    }
                } else {
                    if (this.isMobile) {
                        ban();
                    }
                }
            },
            { passive: true }
        );
    }

    static eventPath(evt) {
        const path = (evt.composedPath && evt.composedPath()) || evt.path;
        const target = evt.target;

        if (path != null) {
            return path;
        }

        if (target === window) {
            return [window];
        }

        function getParents(node, memo = []) {
            memo = memo || [];
            const parentNode = node.parentNode;

            if (!parentNode) {
                return memo;
            } else {
                return getParents(parentNode, memo.concat([parentNode]));
            }
        }

        return [target].concat(getParents(target));
    }

    static mouseMoveUserMenuHandler(event) {
        const path = MainMenu.eventPath(event);

        for (let i = 0; i < path.length; i++) {
            if (
                path[i].id == "myProfileDetail" ||
                (path[i].classList && path[i].classList.contains("user-menu__label"))
            ) {
                return;
            }
        }

        const $btn = $("#userMenuBtn");
        $btn.prop("checked", !$btn.prop("checked"));
        $btn.change();
    }

    static mouseMoveMenuHandler(event) {
        const path = MainMenu.eventPath(event);
        for (let i = 0; i < path.length; i++) {
            if (
                path[i].id == "mmAccordions" ||
                (path[i].classList &&
                    (path[i].classList.contains("main-menu__button") ||
                        path[i].classList.contains("mm-levels") ||
                        path[i].classList.contains("quick-search") ||
                        path[i].classList.contains("EditorWidgetZone")))
            ) {
                return;
            }
        }
        const $btn = $("#mainMenuBtn");
        $btn.prop("checked", !$btn.prop("checked"));
        $btn.change();

        // remove focus class
        $(".topmenu.kurzove-sazky").removeClass("focus");
    }

    // position fixed for body when menu is open (solved bug with scrolling) - only for mobile
    static fixBodyOnMenuOpen() {
        $("#mainMenuBtn").change(function () {
            const { hasSmartbanner, hasNotification, smartBannerHeight, notificationHeight } = useSmartBannerPosition();

            if (!window.matchMedia("(min-width: 768px)").matches) {
                if ($(".main-menu__container").is(":visible")) {
                    $("body").addClass("open-header");
                    $("html").addClass("open-header");
                    MainMenu.showHeader();
                    if (hasSmartbanner) {
                        $("html").addClass("has-smartbanner--at-top");
                        if (hasNotification) {
                            $(".sazka-notification").addClass("sazka-notification--at-top");
                        }
                    }
                } else {
                    $("body").removeClass("open-header");
                    $("html").removeClass("open-header");

                    if (hasSmartbanner) {
                        $("#header").addClass("parallax");
                        if ($("body").hasClass("transparent-header")) {
                            $("#header").addClass("transparent");
                        }
                    }
                }
            } else {
                if ($(this).prop("checked")) {
                    MainMenu.showHeader();
                    setTimeout(() => {
                        document.addEventListener("mousemove", MainMenu.mouseMoveMenuHandler, {
                            passive: true,
                        });
                    }, 400);
                } else {
                    document.removeEventListener("mousemove", MainMenu.mouseMoveMenuHandler);
                    const y = window.pageYOffset;
                    if (hasSmartbanner) {
                        if (y <= 0 + notificationHeight + smartBannerHeight) {
                            $("#header").addClass("parallax");
                            if ($("body").hasClass("transparent-header")) {
                                $("#header").addClass("transparent");
                            }
                        }

                        $("body").removeClass("open-header-tablet");
                    }
                }
            }
            if ($("#mainMenuBtn").prop("checked")) {
                dataLayer.push({
                    event: "action.open.menu",
                });
            }
            if (!MainMenu.dataLayerLogged) {
                MainMenu.dataLayerLogged = true;
                MainMenu.userMenuDataLayer();
            }
        });

        // remove when user resize from mobile to desktop
        window.addEventListener(
            "resize",
            () => {
                if (window.matchMedia("(min-width: 768px)").matches) {
                    if ($("body").hasClass("open-header")) {
                        $("body").removeClass("open-header");
                        $("html").removeClass("open-header");
                    }

                    document.removeEventListener("mousemove", MainMenu.mouseMoveUserMenuHandler);
                    document.removeEventListener("mousemove", MainMenu.mouseMoveMenuHandler);
                } else {
                    if ($("#mainMenuBtn").prop("checked")) {
                        if (!$("body").hasClass("open-header")) {
                            $("body").addClass("open-header");
                            $("html").addClass("open-header");
                        }
                    }
                }
            },
            { passive: true }
        );
    }

    static setMenuBanner() {
        const init = () => {
            const searchElemInMenu = $(".main-menu").find(".quick-search");
            const searchHeight = searchElemInMenu.length ? searchElemInMenu.outerHeight() : 0;
            const accordionHeight =
                $(".main-menu__container").height() - $(".mm-levels").height() - searchHeight - 12 + "px";

            $("#mmAccordions").css("min-height", accordionHeight);
        };

        //on load
        if (window.matchMedia("(min-width: 768px)").matches) {
            setTimeout(function () {
                init();
            }, 1000);
        }

        // remove min-height and height for mobile devices
        window.addEventListener(
            "resize",
            () => {
                if (!window.matchMedia("(min-width: 768px)").matches) {
                    $("#mmAccordions").css("height", "").css("min-height", "");
                } else {
                    init();
                }
            },
            { passive: true }
        );
    }

    static listenMainUserMenu() {
        const $toggleBtn = $(".main-menu__button"),
            $userToggleBtn = $(".user-menu__label");

        $toggleBtn.click(function () {
            // ban to has both menu (user & main) closed
            //timeout to use event loop
            setTimeout(() => {
                if ($("#mainMenuBtn").prop("checked") && $("#userMenuBtn").prop("checked")) {
                    $userToggleBtn.click();
                }
            }, 10);
        });

        $userToggleBtn.click(function () {
            // ban to has both menu (user & main) closed
            //timeout to use event loop
            setTimeout(() => {
                if ($("#userMenuBtn").prop("checked") && $("#mainMenuBtn").prop("checked")) {
                    $toggleBtn.click();
                }
            }, 10);
        });
    }

    // close mainMenu on click Outside the element
    static closeMainMenuOnClickOutsideIt() {
        $("html").click(function (e) {
            // only when the mainMenu is open
            if ($("#mainMenuBtn").prop("checked")) {
                // except selected elements and their children
                if (
                    !($(e.target).closest(".main-menu__overflow").length > 0) &&
                    !$(e.target).hasClass("main-menu__overflow") &&
                    !($(e.target).closest(".main-menu__button").length > 0) &&
                    !$(e.target).hasClass("main-menu__button") &&
                    e.target.id !== "mainMenuBtn"
                ) {
                    $(".main-menu__button").click();
                }
            }

            if (
                $("#userMenuBtn").prop("checked") &&
                !(
                    $(e.target).closest("#myProfileDetail").length ||
                    $(e.target).closest(".user-menu__label").length ||
                    $(e.target).closest("#userMenuBtn").length
                )
            ) {
                $(".user-menu__label").click();
            }
        });
    }

    // scroll to accordion's content when is opened - only for mobile
    static scrollToAccordionsContent() {
        // helper fn to scroll to accordion's content

        $(".mm-accordions__title").click(function () {
            // only on mobile devices
            if (!window.matchMedia("(min-width: 768px)").matches) {
                // when accordion is open scroll to its content
                if ($(this).eq(0).hasClass("collapsed")) {
                    scrollToAnimated(".main-menu__container");
                }
            }
        });
    }

    static closeAllAccordions() {
        $(".mm-accordions__title").attr("aria-expanded", "false");
        $(".mm-accordions__title").removeClass("collapse");
        $(".mm-accordions__title").addClass("collapsed");
        $(".mm-accordions__nav").removeClass("show");
    }

    static animationOnlyOnHover() {
        $(".mm-levels").hover(
            function () {
                if (window.matchMedia("(min-width: 768px)").matches) {
                    $(".mm-levels ul ul").css("transition", "all 0s ease 0s");
                }
            },
            function () {
                if (window.matchMedia("(min-width: 768px)").matches) {
                    $(".mm-levels ul ul").css("transition", "width .25s, left .25s");
                }
            }
        );

        window.addEventListener(
            "resize",
            () => {
                $(".mm-levels ul ul").css("transition", "");
            },
            { passive: true }
        );
    }

    static userMenuDataLayer() {
        const $item = $(".menu-banner");
        if ($item.length) {
            dataLayer.push({
                event: "action.impress.promos",
                action: {
                    impress: {
                        promos: [
                            {
                                id: $item.data("a-codename"),
                                name: "menu",
                                creative: `${location.hostname}${$item.data("a-creative")}`,
                                position: "menu.bottom",
                            },
                        ],
                    },
                },
            });
        }
    }

    static bindDatalayerEvents() {
        $(".quick-nav__item").click((e) => {
            const $elem = $(e.currentTarget);
            this.menuNavigation($elem.data("a-text"));
        });

        $(".header-logo__link").click(() => {
            this.menuNavigation("HP");
        });

        $("#mainMenu [data-a-codename]:not([data-a-codename=''])").on("click", (e) => {
            // web analytics may want to return this for lotteries
            // Analytics.actionTouchpointLotteryPath(e.currentTarget.dataset.aCodename, "menu-", "");

            Analytics.pushMenuClick(e.currentTarget.dataset.aCodename, "menu");
        });

        $("#mmAccordions [data-a-codename]:not([data-a-codename=''])").on("click", (e) => {
            Analytics.pushMenuClick(e.currentTarget.dataset.aCodename, "menu");
        });
    }

    static handleKurzoveSazkyPage() {
        $(".main-menu__button").click(() => {
            const elem = $(".topmenu.kurzove-sazky");

            if (this.isMobile) {
                elem.click();
            } else {
                if (elem.hasClass("focus")) {
                    $(".topmenu.kurzove-sazky").removeClass("focus");
                } else {
                    setTimeout(() => {
                        $(".topmenu.kurzove-sazky").addClass("focus");
                    }, 250);
                }
            }
        });
    }

    static menuNavigation(name: string) {
        dataLayer.push({
            event: "action.click.navigation",
            action: {
                click: {
                    name: name,
                    eventProperty2: "main",
                },
            },
        });
    }

    static setKurzoveSazkyTicketsIconState() {
        window.addEventListener("@@openbet/page-context", function (e) {
            if ((<any>e).detail.context.route === "SportsBetHistory") {
                document.getElementById("myTickets")?.classList.add("selected");
            } else {
                document.getElementById("myTickets")?.classList.remove("selected");
            }
        });
    }
}

export function registerUserMenuBtn() {
    const { hasSmartbanner, hasNotification, smartBannerHeight, notificationHeight } = useSmartBannerPosition();

    if (!window.matchMedia("(min-width: 768px)").matches) {
        if ($("#userMenuBtn").prop("checked")) {
            $("body").addClass("open-header");
            $("html").addClass("open-header");
            MainMenu.showHeader();

            if (hasSmartbanner) {
                $("html").addClass("has-smartbanner--at-top");
                if (hasNotification) {
                    $(".sazka-notification").addClass("sazka-notification--at-top");
                }
            }
        } else {
            $("body").removeClass("open-header");
            $("html").removeClass("open-header");

            if (hasSmartbanner) {
                $("#header").addClass("parallax");
                if ($("body").hasClass("transparent-header")) {
                    $("#header").addClass("transparent");
                }
            }
        }
    } else {
        if ($("#userMenuBtn").prop("checked")) {
            MainMenu.showHeader();
        } else {
            const y = window.pageYOffset;
            if (hasSmartbanner) {
                if (y <= 0 + notificationHeight + smartBannerHeight) {
                    $("#header").addClass("parallax");
                    if ($("body").hasClass("transparent-header")) {
                        $("#header").addClass("transparent");
                    }
                }

                $("body").removeClass("open-header-tablet");
            }
        }
    }
}

export function useMainMenu() {
    MainMenu.setMenuBanner();
    MainMenu.toggleMMLevels();
    MainMenu.fixBodyOnMenuOpen();
    MainMenu.listenMainUserMenu();
    MainMenu.closeMainMenuOnClickOutsideIt();
    MainMenu.scrollToAccordionsContent();
    MainMenu.closeAllAccordions();
    MainMenu.animationOnlyOnHover();
    MainMenu.bindDatalayerEvents();

    if (location.pathname.startsWith("/kurzove-sazky")) {
        MainMenu.handleKurzoveSazkyPage();
        MainMenu.setKurzoveSazkyTicketsIconState();
    }
}
